export const PolicyType = Object.freeze({
    CONSENT_TO_TREATMENT: "CONSENT_TO_TREATMENT",
    HIPAA: "HIPAA",
    PRIVACY: "PRIVACY",
    TERMS_AND_CONDITIONS: "TERMS_AND_CONDITIONS"
});
